import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/system";
import { useLocalStorage } from "@pmag/ui-components";
import { type FunctionComponent, type PropsWithChildren } from "react";
import * as yup from "yup";

import { StyledSplit } from "./SplitView.styles";

export const SplitView: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const theme = useTheme();
    const mdScreen = useMediaQuery(theme.breakpoints.up("md"));
    const [sizes, setSizes] = useLocalStorage("splitViewSizes", [65, 35], yup.array().defined().min(2).max(2));

    if (mdScreen) {
        return (
            <StyledSplit sizes={sizes} minSize={[730, 240]} maxSize={[Infinity, 1024]} expandToMin={true} gutterSize={30} onDragEnd={setSizes}>
                {children}
            </StyledSplit>
        );
    }

    return <>{children}</>;
};
